import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserInfoService } from 'src/app/core/auth/user-info/user-info.service';
import { ConfigParamService } from 'src/app/core/config-param/config-param.service';

export class NavItem {
  title: string = '';
  routerLink: string = '';
  permission?: string;
  icon: string = '';
}

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _opened: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  private _navItems: NavItem[] = [];
  private frontendDisplayUserName: string;
  private frontendPagePermissions: any;

  constructor(
    configParamService: ConfigParamService,
    private userInfoService: UserInfoService
  ) {
    this.frontendDisplayUserName =
      configParamService.getConfigParamByParamName('frontendDisplayUserName')
        ?.paramValueString ?? 'name';
    if (!['name', 'given_name'].includes(this.frontendDisplayUserName)) {
      this.frontendDisplayUserName = 'name';
    }
    this._navItems = [
      {
        title: 'dashboard.card.title.dashboard',
        routerLink: '/protected/dashboard',
        icon: 'dashboard',
      },
      {
        title: 'dashboard.card.title.devices',
        routerLink: '/protected/devices',
        icon: 'list',
        permission: 'devices',
      },
      {
        title: 'dashboard.card.title.hierarchies',
        routerLink: '/protected/hierarchies',
        icon: 'lan',
        permission: 'hierarchies',
      },
      {
        title: 'dashboard.card.title.messages',
        routerLink: '/protected/messages',
        icon: 'mail',
        permission: 'messages',
      },
      {
        title: 'dashboard.card.title.grafana',
        routerLink: '/grafana',
        icon: 'analytics',
        permission: 'grafana',
      },
      {
        title: 'dashboard.card.title.map',
        routerLink: '/protected/map',
        icon: 'map',
        permission: 'map',
      },
    ];

    const frontendPagePermissions =
      configParamService.getConfigParamByParamName('frontendPagePermissions');
    if (frontendPagePermissions === undefined) {
      console.error('page permissions undefined');
    }
    this.frontendPagePermissions = JSON.parse(
      frontendPagePermissions?.paramValueString ?? '{}'
    );
  }

  public get navItems(): NavItem[] {
    return this.filteredNavItems;
  }

  public get dashboardNavItems(): NavItem[] {
    return this.filteredNavItems.filter(
      (item) => item.routerLink !== '/protected/dashboard'
    );
  }

  private get filteredNavItems(): NavItem[] {
    return this._navItems.filter((item) => {
      if (item.permission === undefined) {
        return true;
      }
      const groups = this.frontendPagePermissions[item.permission];
      return this.userInfoService.memberOf?.some((ai: string) =>
        groups?.includes(ai)
      );
    });
  }

  public get opened(): Observable<boolean> {
    return this._opened;
  }

  public setOpen(value: boolean) {
    this._opened.next(value);
  }

  public get userName() {
    return this.frontendDisplayUserName === 'name'
      ? this.userInfoService.userFullName
      : this.userInfoService.userGivenName;
  }
}
